<template>
  <b-modal :title="helper.trans('labels.invite_url')"
           :modelValue="visible"
           body-class="d-flex"
           footer-class="d-flex"
           @update:modelValue="visible = $event">
    <template #default>
      <div class="me-2" :title="url" style="overflow: hidden;text-overflow: ellipsis; white-space: nowrap;">
        <a :href="url" target="_blank">
          <small>{{ url }}</small>
        </a>
      </div>
      <copy-button :value="url"></copy-button>
    </template>
    <template #footer>
      <button type="button" @click="visible = false" class="btn btn-outline-primary btn-sm text-capitalize-first">
        {{ helper.trans('button.ok') }}
      </button>
    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent, ref} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {BModal} from "bootstrap-vue-3";
import {helper} from "@/service/CommonHelper";
import CopyButton from "@/components/CopyButton.vue";

export default defineComponent({
  components: {
    BModal,
    CopyButton
  },
  setup() {
    const state = reactive({
      visible: false as boolean,
      url: '' as string
    });

    const show = (url: string) => {
      state.visible = true
      state.url = url
    }

    const hide = () => {
      state.visible = false
    }


    return {
      ...toRefs(state),
      show,
      hide,
      helper
    }
  }
})
</script>
